import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddDisciplineModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const AddDisciplineModal = () => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  return (
    <div className={st.fieldSet}>
      <FormField>
        <FormLabel isRequired>Discipline:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={'Enter the name of the discipline'}
            name='name'
            value={modalValue?.name || ''}
            onChange={(e) => changeValue(e.target.value, 'name')}
            maxLength={35}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(AddDisciplineModal)
